import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "@assoanalytics/environments/environment";

export class ErrorFormatter {
  /**
   * Formatta un errore HTTP rimuovendo l'URL base e mantenendo solo le informazioni rilevanti
   * @param error Errore HTTP da formattare
   * @returns Messaggio di errore formattato
   */
  static formatHttpError(error: HttpErrorResponse): string {
    if (!error) return "Unknown error";

    // Estrai informazioni rilevanti
    const statusCode = error.status;
    const statusText = error.statusText;
    const errorMessage =
      error.error?.message || error.error?.error || error.message || "";

    // Estrai solo l'endpoint dalla URL completa
    let endpoint = "";
    let queryParams = "";
    try {
      if (error.url) {
        // Rimuovi l'URL base (api, oauth, ecc.) e mantieni solo l'endpoint
        const url = new URL(error.url);

        // Rimuovi i domini conosciuti dall'URL
        endpoint = url.pathname;
        Object.values(environment).forEach((baseUrl) => {
          if (
            typeof baseUrl === "string" &&
            baseUrl &&
            endpoint.startsWith(baseUrl)
          ) {
            endpoint = endpoint.replace(baseUrl, "");
          }
        });

        // Salva i parametri di query separatamente
        if (url.search) {
          queryParams = url.search;
        }
      }
    } catch (e) {
      console.error("Error during endpoint extraction:", e);
    }

    // Costruisci il messaggio formattato
    let formattedMessage = "";
    if (endpoint) {
      formattedMessage += `${endpoint}<br>`;
    }

    if (statusText && statusText !== "Unknown Error") {
      formattedMessage += `${statusCode} (${statusText})`;
    }

    if (errorMessage && !errorMessage.includes(endpoint)) {
      formattedMessage += `${errorMessage}<br>`;
    }

    if (queryParams) {
      formattedMessage += `${queryParams}`;
    }

    return formattedMessage;
  }
}
